module.exports = {"331181001":"龙渊街道","331181002":"西街街道","331181003":"剑池街道","331181004":"石达石街道","331181100":"八都镇","331181101":"上垟镇","331181102":"小梅镇","331181103":"查田镇","331181104":"安仁镇","331181105":"锦溪镇","331181106":"住龙镇","331181107":"屏南镇","331181200":"兰巨乡","331181202":"宝溪乡","331181203":"竹垟畲族乡","331181204":"道太乡","331181205":"岩樟乡","331181206":"城北乡","331181207":"龙南乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/331181.json
// module id = 1137
// module chunks = 0